// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"488":"3c24db89","823":"52bf6b41"}[chunkId] + ".chunk.js");